// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LkGe","colBig":"styles_colBig__3RWJR","colSmall":"styles_colSmall__3elqJ"};